import { FiArrowUpRight } from "react-icons/fi";

const STEPS = [
  {
    number: "01",
    title: "Register Online",
    description: "Sign up in minutes with just your basic details. Quick, simple, and secure.",
  },
  {
    number: "02",
    title: "Complete KYC",
    description: "Upload your documents digitally. 100% paperless verification process.",
  },
  {
    number: "03",
    title: "Get Approved",
    description: "Receive instant approval based on your creditworthiness. No hidden criteria.",
  },
  {
    number: "04",
    title: "Receive Funds",
    description: "Money transferred directly to your bank account within minutes.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="scroll-mt-24 bg-ep-green py-20 text-white lg:pb-[136px] lg:pt-[100px]" aria-labelledby="how-it-works-title">
      <div className="page-container grid gap-12 lg:grid-cols-[400px_minmax(0,1fr)] lg:gap-[60px]">
        {/* Intro */}
        <div className="lg:pt-2.5">
          <h2 id="how-it-works-title" className="ep-section-title text-white">
            How it works
          </h2>
          <p className="mt-6 max-w-[350px] text-base leading-[1.75] text-ep-on-dark lg:mt-8 lg:text-[17px]">
            Get your loan in 4 simple steps. Fast, secure, and completely digital.
          </p>
          <a
            href={import.meta.env.VITE_WEBSITE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="ep-btn ep-btn-light mt-9"
          >
            Apply Now
            <FiArrowUpRight aria-hidden className="text-base" />
          </a>
        </div>

        {/* Steps */}
        <ol className="grid gap-x-10 gap-y-14 sm:grid-cols-2 lg:gap-y-[110px]">
          {STEPS.map((step) => (
            <li key={step.number} className="border-t border-[#A7ACAB] pt-7">
              <span aria-hidden className="block font-serif text-[46px] leading-none text-ep-on-dark lg:text-[50px]">
                {step.number}
              </span>
              <h3 className="mt-6 font-serif text-[28px] font-normal leading-tight text-white lg:text-[30px]">
                {step.title}
              </h3>
              <p className="mt-5 max-w-[400px] text-[15px] leading-[1.75] text-ep-on-dark">
                {step.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
